

const Specifics = () => {
    return <div className="specifics-container">
        <h4>Why Choose Roots & Robust?</h4>
        <p>
            Our comprehensive property management platform combines cutting-edge technology
            with deep industry expertise to deliver unparalleled insights into your rental business.
            From detailed P&L reporting to streamlined expense tracking, we empower property owners
            to make data-driven decisions that maximize profitability and minimize operational headaches.
        </p>
    </div>
};

export default Specifics;